import type { ErrorInfo } from "react";
import { logger } from "@jkast90/kast-common/diagnostics";

/** A crash goes into the logger, so the bug report carries it. */
export const logCrash = (error: Error, info: ErrorInfo) => logger.error(`[Crash] ${error.message}`, info.componentStack ?? "");
